module.exports = __webpack_public_path__ + "img/theroom_bottle_thumb.8bb76ce1.jpg";